<a [href]="link" [target]="target">
    <button mat-stroked-button [color]="color" [class]="classes">
        {{title}}
    </button>
</a>